import { useConversationTasks } from '../hooks/useConversationTasks';
import type { Conversation, Message } from 'types';

type ConversationTasksLoaderProps = {
  conversation?: Conversation | null;
  enabled: boolean;
  messages: Message[];
};

/** Renders nothing; lets class-based ConversationMessages use useConversationTasks. */
export default function ConversationTasksLoader({
  conversation,
  enabled,
  messages,
}: ConversationTasksLoaderProps) {
  useConversationTasks({
    enabled,
    organizationId: conversation?.organizationId,
    counterPartyId: conversation?.counterParty?.id,
    counterPartyType: conversation?.counterPartyType,
    messageIds: messages.map((m) => m.serverId || m.id),
  });
  return null;
}
